var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ClickEventListener } from '@philips-internal/oswald-ui-core/lib/component/types';
export default class TermCheckApi extends ComponentAPI {
    constructor() {
        super(...arguments);
        this.onClickTermo = new ClickEventListener();
        this.onClickTermoConsent = new ClickEventListener();
        this.onClickAviso = new ClickEventListener();
    }
    setValue(value) {
        this.setState({ value });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TermCheckApi.prototype, "onClickTermo", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TermCheckApi.prototype, "onClickTermoConsent", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TermCheckApi.prototype, "onClickAviso", void 0);
//# sourceMappingURL=term-checkbox-api.js.map